export default {
  common: {
    login: 'Se connecter',
    logout: 'Se déconnecter',
    support: 'Service client',
    privacy: 'Politique de confidentialité',
    terms: `Conditions d'utilisation`,
    and: 'et',
    guest: 'Invité·e',
    play: 'Jouer',
    install: 'Installer',
  },
  support: {
    title: `Besoin d'aide?`,
    description: `Si vous jouez à ce jeu et que vous rencontrez des difficultés,
      nous serons heureux de vous aider et de répondre à vos questions.`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption:
      'Aidez Austin le majordome à ramener chaleur et confort au superbe manoir de ses parents.',
    description: `Aidez Austin le majordome à ramener chaleur et confort
      au superbe manoir de ses parents. Rejoignez-nous, des aventures
      vous attendent dès le pas de la porte!`,
  },
  cookie: {
    message: 'Ce site utilise des cookies pour vous assurer la meilleure expérience sur notre site',
    link: `Plus d'infos`,
    button: 'Accepter',
  },
  install: {
    title: '@:common.install',
    text: `Homescapes sur votre bureau !
    Installez la version web du jeu et rendez visite à Austin d'un simple clic !`,
    button: '@:common.install',
  },
  copy: {
    xsolla: 'Xsolla est un distributeur mondial autorisé de Homescapes',
  },
  game: {
    notSupported: `Les appareils mobiles ne sont pas pris en charge.
      Pour jouer, connectez-vous sur un ordinateur.`,
  },
};
